import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLocation } from 'react-router-dom';

export function useHasAiSearchBar(): boolean {
  const { pathname } = useLocation();

  const flags = useFlags();
  const isMsspPage = [
    '/pages/accounts',
    '/pages/mssp-dashboard',
    '/pages/settings/tokens/',
    '/pages/settings/seed-data/',
    '/pages/actionItems/alerts',
    '/pages/assessments/drps/compromisedDevices',
    '/pages/assessments/orgScore'
  ].includes(pathname);

  return !isMsspPage && !!flags?.shouldShowAi;
}
